import { isLocalhost, tickarooPlatformDomain } from "./tickarooPlatformDomain.js";
// The comma-separated qualifiers encoded as liveblog's MediaGw builder emits them (`%2C`).
const GATEWAY_SQUARE = "c_fill%2Cw_128%2Ch_128";
const IMAGESERVICE_VALUE = /^imageservice:\/\/\S+$/;
const NXT_STORAGE_VALUE = /^nxt1:\/\/storage\/[\w.\-/]+$/;
const ORGANIZATION_ID = /^[\w-]+$/;
const HOST_LABEL = /^[a-z0-9-]+$/i;
// The CMS dev gateway, which serves the localhost tenant's Organizations.
const LOCAL_CMS_ORIGIN = "http://localhost:3000";
function isWebAddress(value) {
    try {
        const { protocol } = new URL(value);
        return protocol === "https:" || protocol === "http:";
    }
    catch {
        return false;
    }
}
/**
 * The address a stored liveblog image value (a user's picture, a liveblog Organization's image) loads
 * from, or undefined when it names no loadable image.
 */
export function storedImageUrl(value) {
    if (!value)
        return undefined;
    if (IMAGESERVICE_VALUE.test(value)) {
        const domain = tickarooPlatformDomain();
        return domain ? `https://www.${domain}/mediagw/image/${GATEWAY_SQUARE}/${value}` : undefined;
    }
    return isWebAddress(value) ? value : undefined;
}
function nxtCmsOrigin(tenantSlug) {
    if (isLocalhost(window.location.hostname))
        return LOCAL_CMS_ORIGIN;
    const domain = tickarooPlatformDomain();
    return domain && HOST_LABEL.test(tenantSlug) ? `https://${tenantSlug}.apps.${domain}` : undefined;
}
/**
 * The address an nxt Organization's stored image (`nxt1://storage/…`) loads from: the media gateway
 * on the Organization's tenant host, cropped square. Undefined when it names no loadable image.
 */
export function nxtOrganizationImageUrl(org) {
    const { id, tenantSlug, image } = org;
    if (!image || !NXT_STORAGE_VALUE.test(image) || image.includes("..") || !ORGANIZATION_ID.test(id))
        return undefined;
    const origin = nxtCmsOrigin(tenantSlug);
    return origin ? `${origin}/nxt/mediagw/${id}/image/${GATEWAY_SQUARE}/${image}` : undefined;
}
//# sourceMappingURL=storedImageUrl.js.map